module.exports = __webpack_public_path__ + "img/error-404-message.99820d3d.svg";